<!-- Team Rank-->
<template>
  <div class="tr-list-page">
    <!-- 전체 레이아웃 그리드 -->
    <div class="main-grid-layout">
      <!-- 1. 연도별 매출 그리드 -->
      <div v-if="this.userInfo?.OGN_FG == '00'" class="sales-grid">
        <ag-grid-vue
          class="ag-tr-balham top-grid"
          :columnDefs="totalMonthlyCountColumnDefs"
          :rowData="totalMonthlyCountData"
          :gridOptions="totalMonthlyCountGridOptions"
          :theme="theme"
          style="width: 100%; height: 100%"
        />
      </div>

      <!-- 5. 오른쪽 본부 별 그리드 -->
      <div v-if="this.userInfo?.OGN_FG == '00'" class="monthly-stats-grid">
        <ag-grid-vue
          class="ag-tr-balham top-grid"
          :columnDefs="avgCountColumnDefs"
          :rowData="avgCountData"
          :gridOptions="avgCountGridOptions"
          :theme="theme"
          :pinnedTopRowData="pinnedTopRowData"
          style="width: 100%; height: 100%"
        />
      </div>

      <!-- 2,3,4 영역 컨테이너 -->
      <div v-if="this.userInfo?.OGN_FG == '00'" class="middle-container">
        <!-- 2. 달력 그리드 -->
        <div class="group-grid">
          <ag-grid-vue
            class="ag-tr-balham middle-grid"
            :columnDefs="dailyLastSalesCountColumnDefs"
            :rowData="dailyLastSalesCountData"
            :gridOptions="dailyLastSalesCountGridOptions"
            :theme="theme"
            style="width: 100%; height: 100%"
          />
        </div>

        <!-- 3. 달력 그리드 -->
        <div class="right-stats-grid">
          <ag-grid-vue
            class="ag-tr-balham middle-grid"
            :columnDefs="dailySalesCountColumnDefs"
            :rowData="dailySalesCountData"
            :gridOptions="dailySalesCountGridOptions"
            :theme="theme"
            style="width: 100%; height: 100%"
          />
        </div>

        <!-- 4. 통계 테이블 -->
        <div class="stats-table">
          <table>
            <tbody>
              <tr>
                <th>월계</th>
                <td>{{ formatNumber(totalSaleData[0]?.ALL_MONTH_QTY) }}</td>
              </tr>
              <tr>
                <th>월예상</th>
                <td>{{ formatNumber(Math.round(monthlyProjectedValue)) }}</td>
              </tr>
              <tr>
                <th>연누계</th>
                <td>{{ formatNumber(totalSaleData[0]?.ALL_YEAR_QTY) }}</td>
              </tr>
              <tr>
                <th>연예상</th>
                <td>{{ formatNumber(totalSaleData[0]?.EXP_YEAR_QTY) }}</td>
              </tr>
              <tr>
                <th>일평균</th>
                <td>{{ formatNumber(totalSaleData[0]?.DAY_AVG_QTY) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 6. 검색 영역 -->
      <div class="search-section">
        <div class="info-label">본부</div>
        <select
          v-model="selectedBranch"
          class="branch-select"
          @change="onBranchChange"
          :disabled="userInfo && userInfo.OGN_FG === '01'"
        >
          <option
            v-for="branch in branchList"
            :key="branch.BRANCH_CD"
            :value="branch.BRANCH_CD"
          >
            {{ branch.BRANCH_NM }}
          </option>
        </select>
        <div class="info-label">매장명</div>
        <input
          type="text"
          placeholder="검색"
          @input="onQuickFilterChanged"
          class="search-input"
        />

        <div class="month-control">
          <button
            @click="decreaseMonth"
            class="month-btn"
            :disabled="selectedMonth === 1 || isLoading"
          >
            ◀
          </button>
          <span class="month-display">{{ selectedMonth }}월</span>
          <button
            @click="increaseMonth"
            class="month-btn"
            :disabled="isCurrentMonth || isLoading"
          >
            ▶
          </button>
        </div>
        <button
            class="refresh-btn"
            @click="storeCountCopy"
            v-if="['관리자','육상용','남상만'].includes(userInfo?.EMP_NM) || ['zzzooo0212'].includes(userInfo?.userId)"
          >
            복사
          </button>
        <button @click="refreshPage" class="refresh-btn">새로고침</button>
      </div>

      <!-- 7. 하단 그리드 -->
      <div class="bottom-grid">
        <ag-grid-vue
          class="ag-tr-balham"
          :columnDefs="storeCountColumnDefs"
          :rowData="storeCountData"
          :gridOptions="storeCountGridOptions"
          :theme="theme"
          @grid-ready="onGridReady"
          :pinnedTopRowData="storeCountPinnedTopRowData"
          style="width: 100%; height: 100%"
          @cell-double-clicked="onStoreCountDoubleClicked"
          @cell-value-changed="onStoreCountCellValueChanged"
          @sort-changed="onSortChanged"
        />
      </div>
      <TrListPopPage v-if="showPopup" :shopCd="popupShopCd" :shopNm="popupShopNm" @close="closePopup" />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
import { themeBalham } from "ag-grid-community";
import TrListPopPage from "./TrListPopPage.vue";

export default {
  name: "TrListPage",
  components: { AgGridVue, TrListPopPage },
  data() {
    return {
      selectedBranch: "", // 선택된 본부
      branchList: [],

      quickFilterText: "",

      gridApi: null,
      totalMonthlyCountGridApi: null,
      avgCountGridApi: null,
      dailyLastSalesCountGridApi: null,
      dailySalesCountGridApi: null,

      showPopup: false,
      popupShopCd: "",
      popupShopNm: "",

      isLoading: false, // 로딩 상태

      userInfo: null, // 로그인한 사용자 정보

      // selectedYear: new Date().getFullYear(),
      selectedMonth: new Date().getMonth() + 1,

      theme: themeBalham.withParams({
        fontFamily: "Malgun Gothic",
        rowHeight: 16,
        borderColor: "#808080",
        wrapperBorder: true,
        headerRowBorder: true,
        headerColumnBorderHeight: "100%",
        rowBorder: { style: "solid", width: 1 },
        columnBorder: { style: "solid", width: 1 },
      }),

      totalMonthlyCountData: [],
      totalMonthlyCountColumnDefs: [
        {
          headerName: "",
          field: "TITLE",
          cellStyle: { backgroundColor: "#a6ef63", justifyContent: "center" },
          flex: 1.12,
        },
        ...[...Array(12).keys()].map((i) => ({
          headerName: `${i + 1}월`,
          field: `M${i + 1}`,
          flex: 1.2,
          valueFormatter: (params) => this.formatNumber(params.value),
          cellStyle: (params) => {
            let style = {};
            style.justifyContent = "right";
            const monthKey = `M${i + 1}`;
            const isMaxValue =
              Number(params.value) ===
              Number(params.data.maxValues?.[monthKey]);
            if (params.data.TITLE !== "차이" && isMaxValue) {
              style.color = "red";
            }
            if (params.data.TITLE === "차이" || params.data.TITLE === "계약차이") {
              if (params.value < 0) {
                style.color = "blue";
              } else {
                style.color = "red";
              }
            }
            return style;
          },
        })),
        {
          headerName: "합계",
          field: "MSUM",
          flex: 1.32,
          valueGetter: (params) => {
            let sum = 0;
            for (let i = 1; i <= 12; i++) {
              sum += Number(params.data?.[`M${i}`] || 0);
            }
            return sum;
          },
          valueFormatter: (params) => this.formatNumber(params.value),
          cellStyle: { backgroundColor: "#fedafb", justifyContent: "right" },
        },
      ],
      totalMonthlyCountGridOptions: {
        headerHeight: 22,
        rowHeight: 20,
        suppressHorizontalScroll: false,
        defaultColDef: {
          sortable: false,
          resizable: true,
          headerStyle: {
            color: "black",
            textAlign: "center",
            backgroundColor: "#a6ef63",
          },
        },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
      },

      dailySalesCountData: [],
      // dailySalesCountColumnDefs: [],
      dailySalesCountGridOptions: {
        headerHeight: 24,
        rowHeight: 22,
        suppressHorizontalScroll: false,
        defaultColDef: {
          sortable: false,
          resizable: false,
          headerStyle: {
            color: "black",
            textAlign: "center",
            backgroundColor: "#c0ffc0",
            alignContent: "center",
          },
        },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
      },

      dailyLastSalesCountData: [],
      // dailyLastSalesCountColumnDefs: [],
      dailyLastSalesCountGridOptions: {
        headerHeight: 24,
        rowHeight: 22,
        suppressHorizontalScroll: false,
        defaultColDef: {
          sortable: false,
          resizable: false,
          headerStyle: {
            color: "black",
            textAlign: "center",
            backgroundColor: "#a0caf3",
            alignContent: "center",
          },
        },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
      },

      totalSaleData: [],

      avgCountData: [],
      avgCountColumnDefs: [
        {
          headerName: "NO",
          valueGetter: "node.rowPinned === 'top' ? '' : node.rowIndex + 1",
          cellStyle: this.avgCountCellStyle,

          width: 18,
          pinned: "left",
        },
        {
          headerName: "평균점수",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "본부",
              field: "ZPOINT_BRANCH_NM",
              flex: 1,
              valueGetter: (params) => {
                if (params.node.rowPinned === "top") return "전체";
                return params.data?.ZPOINT_BRANCH_NM;
              },
              cellStyle: this.avgCountCellStyle,
              cellClass: this.avgCountcellClass,
            },
            {
              headerName: "점수",
              field: "ZPOINT_RATE",
              flex: 1,
              valueFormatter: (params) => {
                return Number(params.value).toFixed(1);
              },
              cellStyle: this.avgCountCellStyle,
              cellClass: this.avgCountcellClass,
            },
          ],
        },
        {
          headerName: "평균수량",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "본부",
              field: "ZXD_BRANCH_NM",
              flex: 1,
              cellStyle: this.avgCountCellStyle,
              cellClass: this.avgCountcellClass,
            },
            {
              headerName: "점평",
              field: "year",
              flex: 1,
              valueGetter: (params) =>
                (params.data.ZXD_SALE_QTY || 0) /
                (params.data.ZXD_SHOP_CNT || 0),
              valueFormatter: (params) => {
                const v = Number(params.value);
                if (!isFinite(v)) return "";
                return Math.round(v).toLocaleString();
              },
              cellStyle: this.avgCountCellStyle,
              cellClass: this.avgCountcellClass,
            },
          ],
        },
        {
          headerName: "대당판매비율",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "본부",
              field: "ZXE_BRANCH_NM",
              flex: 1,
              cellStyle: this.avgCountCellStyle,
              cellClass: this.avgCountcellClass,
            },
            {
              headerName: "당일",
              field: "year",
              flex: 1,
              valueGetter: (params) =>
                (params.data.ZXE_SALE_QTY || 0) /
                (params.data.ZXE_SALE_CNT || 0),
              valueFormatter: (params) => {
                return Number(params.value).toFixed(2);
              },
              cellStyle: this.avgCountCellStyle,
              cellClass: this.avgCountcellClass,
            },
            {
              headerName: "본부",
              field: "ZXF_BRANCH_NM",
              flex: 1,
              cellStyle: this.avgCountCellStyle,
              cellClass: this.avgCountcellClass,
            },
            {
              headerName: "누적",
              field: "year",
              flex: 1,
              valueGetter: (params) =>
                (params.data.ZXF_SALE_QTY || 0) /
                (params.data.ZXF_SALE_CNT || 0),
              valueFormatter: (params) => {
                return Number(params.value).toFixed(2);
              },
              cellStyle: this.avgCountCellStyle,
              cellClass: this.avgCountcellClass,
            },
          ],
        },
      ],
      avgCountGridOptions: {
        headerHeight: 24,
        rowHeight: 22,
        suppressHorizontalScroll: false,
        defaultColDef: {
          sortable: false,
          resizable: false,
          headerStyle: {
            color: "black",
            textAlign: "center",
            backgroundColor: "#a0caf3",
            alignContent: "center",
          },
        },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
      },
      // 상단 고정행 추가
      pinnedTopRowData: [{}],
      // 평균값 계산 및 상단 고정행 데이터 설정
      calculateAverages() {
        if (!this.avgCountData || this.avgCountData.length === 0) return;

        const averages = {
          ZPOINT_BRANCH_NM: "",
          ZPOINT_RATE: 0,
          ZXD_BRANCH_NM: "",
          ZXD_SALE_QTY: 0,
          ZXD_SHOP_CNT: 0,
          ZXE_BRANCH_NM: "",
          ZXE_SALE_QTY: 0,
          ZXE_SALE_CNT: 0,
          ZXF_BRANCH_NM: "",
          ZXF_SALE_QTY: 0,
          ZXF_SALE_CNT: 0,
        };

        // 평균 계산
        const len = this.avgCountData.length;
        this.avgCountData.forEach((row) => {
          averages.ZPOINT_RATE += Number(row.ZPOINT_RATE || 0);
          averages.ZXD_SALE_QTY += Number(row.ZXD_SALE_QTY || 0);
          averages.ZXD_SHOP_CNT += Number(row.ZXD_SHOP_CNT || 0);
          averages.ZXE_SALE_QTY += Number(row.ZXE_SALE_QTY || 0);
          averages.ZXE_SALE_CNT += Number(row.ZXE_SALE_CNT || 0);
          averages.ZXF_SALE_QTY += Number(row.ZXF_SALE_QTY || 0);
          averages.ZXF_SALE_CNT += Number(row.ZXF_SALE_CNT || 0);
        });

        // 평균값 계산
        averages.ZPOINT_RATE = (averages.ZPOINT_RATE / len).toFixed(1);
        averages.ZXD_AVG = (
          averages.ZXD_SALE_QTY / averages.ZXD_SHOP_CNT || 0
        ).toFixed(0);
        averages.ZXE_AVG = (
          averages.ZXE_SALE_QTY / averages.ZXE_SALE_CNT || 0
        ).toFixed(2);
        averages.ZXF_AVG = (
          averages.ZXF_SALE_QTY / averages.ZXF_SALE_CNT || 0
        ).toFixed(2);

        // pinnedTopRowData 업데이트
        this.pinnedTopRowData = [averages];
      },

      storeCountData: [],
      storeCountColumnDefs: [
        {
          headerName: "매장정보",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "No.",
              field: "no",
              valueGetter: "node.rowPinned === 'top' ? '' : node.rowIndex + 1",
              width: 25,
              flex: 0.6,
              pinned: "left",
              sortable: false,
              cellStyle: {
                justifyContent: "center",
                backgroundColor: "#a0caf3",
              },
            },
            {
              headerName: "점번",
              field: "VAN_BIZ_NO",
              width: 30,
              flex: 1,
              pinned: "left",
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "점포명",
              field: "SHOP_NM",
              width: 80,
              flex: 1,
              pinned: "left",
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "사업주명",
              field: "SHOP_MASTER_NM",
              width: 60,
              flex: 1,
              pinned: "left",
              editable: (params) => !params.node.rowPinned && (this.userInfo?.OGN_FG !== "00" || this.userInfo?.EMP_DEPT_NM === "관리자팀"),
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "나이",
              width: 30,
              field: "AGE",
              flex: 1,
              pinned: "left",
              editable: (params) => !params.node.rowPinned && (this.userInfo?.OGN_FG !== "00" || this.userInfo?.EMP_DEPT_NM === "관리자팀"),
              valueSetter: (params) => {
                const newValue = params.newValue;
                if (!isNaN(newValue) && newValue !== '') {
                  params.data.AGE = Number(newValue);
                  return true;
                }
                return false; // 숫자가 아니면 반영하지 않음
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "경력",
              field: "CAREER",
              width: 30,
              flex: 1,
              pinned: "left",
              editable: (params) => !params.node.rowPinned && (this.userInfo?.OGN_FG !== "00" || this.userInfo?.EMP_DEPT_NM === "관리자팀"),
              valueSetter: (params) => {
                const newValue = params.newValue;
                if (!isNaN(newValue) && newValue !== '') {
                  params.data.CAREER  = Number(newValue);
                  return true;
                }
                return false; // 숫자가 아니면 반영하지 않음
              },
              // cellStyle: { textAlign: "right", backgroundColor: "#ffffbb" },
              cellStyle: (params) => {
                const style = {
                  justifyContent: "right",
                  backgroundColor: "#ffffbb",
                };
                if (params.node.rowPinned === "top") {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                return style;
              },
            },
            {
              headerName: "기준\n약정금",
              field: "IndexGOAL_MM",
              width: 70,
              flex: 1,
              pinned: "left",
              valueFormatter: (params) => {
                if (params.value == null) return "";
                if (params.node.rowPinned !== "top") {
                  return Math.round(
                    Number(params.value) / 10000
                  ).toLocaleString();
                }
                return Number(params.value).toLocaleString();
              },
              cellStyle: (params) => {
                const style = {
                  justifyContent: "right",
                  backgroundColor: "#ffebe6",
                };
                if (params.node.rowPinned === "top") {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                return style;
              },
            },
            {
              headerName: "당월\n약정금",
              field: "GOAL_MM",
              width: 70,
              flex: 1,
              pinned: "left",
              valueFormatter: (params) => {
                if (params.value == null) return "";
                if (params.node.rowPinned !== "top") {
                  return Math.round(
                    Number(params.value) / 10000
                  ).toLocaleString();
                }
                return Number(params.value).toLocaleString();
              },
              cellStyle: (params) => {
                const style = {
                  justifyContent: "right",
                  backgroundColor: "#ffcbff", // 연보라
                };
                if (params.node.rowPinned !== "top") {
                  if (
                    params.data &&
                    Math.round(params.data.GOAL_MM / 10000) >
                      Math.round(params.data.IndexGOAL_MM / 10000)
                  ) {
                    style.color = "#FF0000";
                  } else if (
                    params.data.GOAL_MM / 1000 <
                    params.data.IndexGOAL_MM / 1000
                  ) {
                    style.color = "#0000FF";
                  } else {
                    style.color = "#000000";
                  }
                } else {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                return style;
              },
            },
            {
              headerName: "계약\n만료일",
              field: "ZK_SURETY_ED",
              width: 80,
              flex: 1,
              pinned: "left",
              cellStyle: (params) => {
                const style = {
                  justifyContent: "center",
                  backgroundColor: "#fff200",
                };
                if (params.node.rowPinned === "top") {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                return style;
              },
            },
          ],
        },
        {
          headerName: "인원관리",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            justifyContent: "center",
          },
          children: [
            {
              headerName: "기준TO",
              field: "STD_TO",
              minWidth: 60,
              flex: 1,
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "당월TO",
              field: "TO_CNT",
              minWidth: 60,
              flex: 1,
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "PO",
              field: "STAFF_CNT",
              minWidth: 60,
              flex: 1,
              editable: (params) => !params.node.rowPinned && (this.userInfo?.OGN_FG !== "00" || this.userInfo?.EMP_DEPT_NM === "관리자팀"),
              valueSetter: (params) => {
                const newValue = params.newValue;
                if (!isNaN(newValue) && newValue !== '') {
                  params.data.STAFF_CNT  = Number(newValue);
                  return true;
                }
                return false; // 숫자가 아니면 반영하지 않음
              },
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: this.storeCountCellStyle,
            },
          ],
        },
        {
          headerName: "수익관리",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            justifyContent: "center",
          },
          children: [
            {
              headerName: "적자",
              minWidth: 70,
              flex: 1,
              valueGetter: (params) => {
                if (params.node.rowPinned === "top") {
                  return params.data.inTheRed;
                }
                if (!params.data) return 0;
                const total =
                  Number(params.data.LASTPROFIT || 0) +
                  Number(params.data.PROFIT || 0);
                return total >= 0 ? 0 : total;
              },
              valueFormatter: (params) => {
                return Number(params.value).toLocaleString();
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "흑자",
              minWidth: 70,
              flex: 1,
              valueGetter: (params) => {
                if (params.node.rowPinned === "top") {
                  return params.data.inTheBlack;
                }
                if (!params.data) return 0;
                const total =
                  Number(params.data.LASTPROFIT || 0) +
                  Number(params.data.PROFIT || 0);
                return total < 0 ? 0 : total;
              },
              valueFormatter: (params) => {
                return Number(params.value).toLocaleString();
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "전월\n누적",
              field: "LASTPROFIT",
              minWidth: 70,
              flex: 1,
              editable: (params) => !params.node.rowPinned && (this.userInfo?.OGN_FG !== "00" || this.userInfo?.EMP_DEPT_NM === "관리자팀"),
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: (params) => {
                const style = {
                  justifyContent: "right",
                };
                if (params.node.rowPinned !== "top") {
                  if (params.data && params.data.LASTPROFIT < 0) {
                    style.color = "#0000FF";
                  } else {
                    style.color = "#FF0000";
                  }
                } else {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                return style;
              },
            },
            {
              headerName: "당월\n수익",
              field: "PROFIT",
              minWidth: 70,
              flex: 1,
              editable: (params) => !params.node.rowPinned && (this.userInfo?.OGN_FG !== "00" || this.userInfo?.EMP_DEPT_NM === "관리자팀"),
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: (params) => {
                const style = {
                  justifyContent: "right",
                };
                if (params.node.rowPinned !== "top") {
                  if (params.data && params.data.PROFIT < 0) {
                    style.color = "#0000FF";
                  } else {
                    style.color = "#FF0000";
                  }
                } else {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                return style;
              },
            },
            {
              headerName: "수익\n합계",
              minWidth: 70,
              flex: 1,
              valueGetter: (params) =>
                Number(params.data.LASTPROFIT || 0) +
                Number(params.data.PROFIT || 0),
              valueFormatter: (params) => {
                return Number(params.value).toLocaleString();
              },
              cellStyle: (params) => {
                const style = {
                  justifyContent: "right",
                };
                if (params.node.rowPinned !== "top") {
                  if (
                    params.data &&
                    Number(params.data.LASTPROFIT || 0) +
                      Number(params.data.PROFIT || 0) <
                      0
                  ) {
                    style.color = "#0000FF";
                  } else {
                    style.color = "#FF0000";
                  }
                } else {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                return style;
              },
            },
          ],
        },
        {
          headerName: "",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            justifyContent: "center",
          },
          children: [
            {
              headerName: "타입",
              field: "TRBIZ_TYPE",
              minWidth: 50,
              flex: 1,
              cellStyle: (params) => {
                const style = {
                  justifyContent: "center",
                  backgroundColor: "#bbddff",
                };
                if (params.node.rowPinned === "top") {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                return style;
              },
            },
            {
              headerName: "평균\n점수",
              minWidth: 50,
              flex: 1,
              valueGetter: (params) =>
                Number(params.data.ZASUM_POINT || 0) /
                Number(params.data.MM_SALE_QTY || 0),
              valueFormatter: (params) => {
                return (Math.round((params.value || 0) * 10) / 10).toFixed(1);
              },
              cellStyle: (params) => {
                const style = {
                  justifyContent: "right",
                  backgroundColor: "#bbddff",
                };
                if (params.node.rowPinned === "top") {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                return style;
              },
            },
          ],
        },
        // 260908 비율관리 항목 신규추가
        {
          headerName: "비율관리",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "필터\n판매비율",
              field: "FILTER_RATIO",
              minWidth: 60,
              flex: 1,
              valueFormatter: (params) => {
                return Number(params.value || 0).toFixed(2) + "%";
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "와이퍼\n판매비율",
              field: "WIPER_RATIO",
              minWidth: 70,
              flex: 1,
              valueFormatter: (params) => {
                return Number(params.value || 0).toFixed(2) + "%";
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "넥센\n판매비율",
              field: "NEX_RATIO",
              minWidth: 70,
              flex: 1,
              valueFormatter: (params) => {
                return Number(params.value || 0).toFixed(2) + "%";
              },
              cellStyle: this.storeCountCellStyle,
            },
          ],
        },
        {
          headerName: "수량관리",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "당일",
              field: "DD_SALE_QTY",
              minWidth: 60,
              flex: 1,
              comparator: (valueA, valueB) => {
                const a = Number(valueA);
                const b = Number(valueB);

                // valueA가 null, undefined, NaN일 경우
                if (valueA == null || isNaN(a)) return 1;
                // valueB가 null, undefined, NaN일 경우
                if (valueB == null || isNaN(b)) return -1;

                // 둘 다 유효한 숫자일 경우
                return a - b;
              },
              valueFormatter: (params) => {
                return Number(params.value).toLocaleString();
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "당월",
              field: "MM_SALE_QTY",
              minWidth: 70,
              flex: 1,
              comparator: (valueA, valueB) => {
                const a = Number(valueA);
                const b = Number(valueB);

                // valueA가 null, undefined, NaN일 경우
                if (valueA == null || isNaN(a)) return 1;
                // valueB가 null, undefined, NaN일 경우
                if (valueB == null || isNaN(b)) return -1;

                // 둘 다 유효한 숫자일 경우
                return a - b;
              },
              valueFormatter: (params) => {
                return Number(params.value).toLocaleString();
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "예상수량",
              field: "EXP_QTY",
              minWidth: 70,
              flex: 1,
              valueFormatter: (params) => this.formatNumber(params.value),
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "최고수량",
              field: "ZJ_L_4_MAX_QTY",
              minWidth: 70,
              flex: 1,
              valueFormatter: (params) => {
                return Number(params.value).toLocaleString();
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "수량차이",
              minWidth: 70,
              flex: 1,
              valueGetter: (params) => {
                const goalQty = params.data.ZJ_L_4_MAX_QTY;
                const expQty = params.data.EXP_QTY;
                // 조건: GOAL_QTY가 빈 문자열이 아니면 계산
                if (goalQty !== "" && goalQty != null) {
                  return Math.round(expQty - goalQty);
                }
                return 0;
              },
              valueFormatter: (params) => {
                return Number(params.value).toLocaleString();
              },
              cellStyle: (params) => {
                const style = { justifyContent: "right" };
                const goalQty = params.data.ZJ_L_4_MAX_QTY;

                // goalQty가 유효한 값일 때만 스타일 계산
                if (params.node.rowPinned !== "top") {
                  if (goalQty !== "" && goalQty != null) {
                    const diff = Math.round(
                      (params.data.EXP_QTY || 0) - (goalQty || 0)
                    );

                    // 글자색 설정
                    if (params.node.rowPinned !== "top") {
                      if (diff >= 0) {
                        style.color = "#FF0000"; // red
                      } else {
                        style.color = "#0000FF"; // blue
                      }

                      // 배경색 설정
                      if (diff <= 0 && diff >= -50) {
                        style.backgroundColor = "#00FF00"; // green
                      } else if (diff < -50 && diff >= -100) {
                        style.backgroundColor = "#f7ff4f"; // H4FFFF7 -> RGB(247, 255, 255)와 유사
                      } else if (diff <= -101) {
                        style.backgroundColor = "#FF0000"; // red
                      } else {
                        style.backgroundColor = "#FFFFFF"; // white
                      }
                    }
                  }
                } else {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                return style;
              },
            },
            {
              headerName: "최고대비\n증감률",
              minWidth: 60,
              flex: 1,
              valueGetter: (params) => {
                const goalQty = params.data.ZJ_L_4_MAX_QTY;
                const expQty = params.data.EXP_QTY;
                // 조건: GOAL_QTY가 빈 문자열이 아니면 계산
                if (goalQty && Number(goalQty) !== 0) {
                  return ((expQty || 0) / goalQty) * 100 - 100;
                }
                return 0;
              },
              valueFormatter: (params) => {
                return Number(params.value || 0).toFixed(2);
              },
              cellStyle: this.storeCountCellStyle,
            },
          ],
        },
        {
          headerName: "매출관리",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "총매출액",
              field: "ZG_S4",
              minWidth: 70,
              flex: 1,
              valueFormatter: (params) => {
                return Number(params.value).toLocaleString();
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "현금매출",
              field: "ZG_S5",
              minWidth: 60,
              flex: 1,
              valueFormatter: (params) => {
                return Number(params.value).toLocaleString();
              },
              cellStyle: this.storeCountCellStyle,
            },
          ],
        },
        {
          headerName: "달성점수",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "10이하",
              field: "SALERATE_10",
              minWidth: 60,
              flex: 1,
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "20이하",
              field: "SALERATE_20",
              minWidth: 60,
              flex: 1,
              valueFormatter: (params) => {
                return Number(params.value || 0).toLocaleString();
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "일계",
              field: "ZDASUM_POINT_DAY",
              minWidth: 70,
              flex: 1,
              valueFormatter: (params) => {
                return Number(params.value).toLocaleString();
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "누계",
              field: "ZASUM_POINT",
              minWidth: 70,
              flex: 1,
              valueFormatter: (params) => {
                return Number(params.value).toLocaleString();
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "예상",
              minWidth: 70,
              flex: 1,
              valueGetter: (params) => {
                const zasumPoint = Number(params.data.ZASUM_POINT ?? NaN);

                // zasumPoint가 빈값/NaN이 아니면 계산
                if (!isNaN(zasumPoint)) {
                  const today = new Date();
                  const currentDay = today.getDate();
                  const lastDay = new Date(
                    today.getFullYear(),
                    today.getMonth() + 1,
                    0
                  ).getDate();

                  return (zasumPoint / currentDay) * lastDay;
                }

                return 0; // zasumPoint가 없으면 빈칸
              },
              valueFormatter: (params) => {
                return Math.round(Number(params.value)).toLocaleString();
              },
              cellStyle: this.storeCountCellStyle,
            },
          ],
        },
        {
          headerName: "고객분석",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "당 일",
              field: "ZCBCST_DAY",
              minWidth: 60,
              flex: 1,
              comparator: (valueA, valueB) => {
                const a = Number(valueA);
                const b = Number(valueB);

                // valueA가 null, undefined, NaN일 경우
                if (valueA == null || isNaN(a)) return 1;
                // valueB가 null, undefined, NaN일 경우
                if (valueB == null || isNaN(b)) return -1;

                // 둘 다 유효한 숫자일 경우
                return a - b;
              },
              valueFormatter: (params) => {
                return Number(params.value).toLocaleString();
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "당 월",
              field: "ZCCCST_THIS",
              minWidth: 60,
              flex: 1,
              comparator: (valueA, valueB) => {
                const a = Number(valueA);
                const b = Number(valueB);

                // valueA가 null, undefined, NaN일 경우
                if (valueA == null || isNaN(a)) return 1;
                // valueB가 null, undefined, NaN일 경우
                if (valueB == null || isNaN(b)) return -1;

                // 둘 다 유효한 숫자일 경우
                return a - b;
              },
              valueFormatter: (params) => {
                return Number(params.value).toLocaleString();
              },
              cellStyle: this.storeCountCellStyle,
            },
            {
              headerName: "누 적",
              field: "ZCDCST_TOT",
              minWidth: 70,
              flex: 1,
              comparator: (valueA, valueB) => {
                const a = Number(valueA);
                const b = Number(valueB);

                // valueA가 null, undefined, NaN일 경우
                if (valueA == null || isNaN(a)) return 1;
                // valueB가 null, undefined, NaN일 경우
                if (valueB == null || isNaN(b)) return -1;

                // 둘 다 유효한 숫자일 경우
                return a - b;
              },
              valueFormatter: (params) => {
                return Number(params.value).toLocaleString();
              },
              cellStyle: this.storeCountCellStyle,
            },
          ],
        },
        {
          headerName: "개폐점관리",
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
            textAlign: "center",
          },
          children: [
            {
              headerName: "개점\n시간",
              field: "OPEN_HR",
              minWidth: 50,
              flex: 1,
              cellStyle: (params) => {
                const style = {
                  justifyContent: "center",
                };
                if (params.node.rowPinned === "top") {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }

                const openHr = params.data.OPEN_HR || "";
                if (openHr != "") {
                  if (
                    params.data &&
                    parseInt(openHr.substring(0, 2), 10) >= 9
                  ) {
                    style.color = "#FF0000";
                  }
                }
                return style;
              },
            },
            {
              headerName: "전일\n폐점",
              field: "CLOSE_HR",
              minWidth: 50,
              flex: 1,
              cellStyle: (params) => {
                const style = {
                  justifyContent: "center",
                };
                if (params.node.rowPinned === "top") {
                  style.backgroundColor = "#dedfde";
                  style.borderColor = "#FF0000";
                }
                const closeHr = params.data.CLOSE_HR || "";
                if (closeHr != "") {
                  if (
                    params.data &&
                    parseInt(closeHr.substring(0, 2), 10) > 19
                  ) {
                    style.color = "#FF0000";
                  }
                }
                return style;
              },
            },
          ],
        },
      ],
      storeCountPinnedTopRowData: [],
      calculateStoreCountAverages() {
        if (!this.storeCountData || this.storeCountData.length === 0) return;

        const averages = {
          VAN_BIZ_NO: "",
          SHOP_NM: "",
          SHOP_MASTER_NM: "합계",
          AGE: 0,
          CAREER: 0,
          IndexGOAL_MM: 0,
          GOAL_MM: 0,
          STD_TO: 0,
          TO_CNT: 0,
          STAFF_CNT: 0,
          // 흑자, 적자
          inTheBlack: 0,
          inTheRed: 0,
          LASTPROFIT: 0,
          PROFIT: 0,
          FILTER_RATIO: 0,  // FILTER_RATIO,WIPER_RATIO,NEX_RATIO 260908 추가
          WIPER_RATIO: 0,
          NEX_RATIO: 0,
          DD_SALE_QTY: 0,
          MM_SALE_QTY: 0,
          EXP_QTY: 0,
          ZJ_L_4_MAX_QTY: 0,
          ZG_S4: 0,
          ZG_S5: 0,
          SALERATE_10: 0,
          SALERATE_20: 0,
          ZDASUM_POINT_DAY: 0,
          ZASUM_POINT: 0,
          ZCBCST_DAY: 0,
          ZCCCST_THIS: 0,
          ZCDCST_TOT: 0,
        };

        const len = this.storeCountData.length;

        // 평균 계산
        this.storeCountData.forEach((row) => {
          averages.AGE += Number(row.AGE || 0);
          averages.CAREER += Number(row.CAREER || 0);
          averages.IndexGOAL_MM += Math.round(
            Number(row.IndexGOAL_MM || 0) / 10000
          );
          averages.GOAL_MM += Math.round(Number(row.GOAL_MM || 0) / 10000);
          averages.STD_TO += Number(row.STD_TO || 0);
          averages.TO_CNT += Number(row.TO_CNT || 0);
          averages.STAFF_CNT += Number(row.STAFF_CNT || 0);

          // 흑자/적자 계산
          const total = Number(row.LASTPROFIT || 0) + Number(row.PROFIT || 0);
          if (total >= 0) {
            averages.inTheBlack += total; // 흑자 합계
          } else {
            averages.inTheRed += total; // 적자 합계
          }

          averages.LASTPROFIT += Number(row.LASTPROFIT || 0);
          averages.PROFIT += Number(row.PROFIT || 0);
          
          averages.FILTER_RATIO += Number(row.FILTER_RATIO || 0);
          averages.WIPER_RATIO += Number(row.WIPER_RATIO || 0);
          averages.NEX_RATIO += Number(row.NEX_RATIO || 0);

          averages.DD_SALE_QTY += Number(row.DD_SALE_QTY || 0);
          averages.MM_SALE_QTY += Number(row.MM_SALE_QTY || 0);
          averages.EXP_QTY += Number(row.EXP_QTY || 0);
          averages.ZJ_L_4_MAX_QTY += Number(row.ZJ_L_4_MAX_QTY || 0);
          averages.ZG_S4 += Number(row.ZG_S4 || 0);
          averages.ZG_S5 += Number(row.ZG_S5 || 0);
          averages.SALERATE_10 += Number(row.SALERATE_10 || 0);
          averages.SALERATE_20 += Number(row.SALERATE_20 || 0);
          averages.ZDASUM_POINT_DAY += Number(row.ZDASUM_POINT_DAY || 0);
          averages.ZASUM_POINT += Number(row.ZASUM_POINT || 0);
          averages.ZCBCST_DAY += Number(row.ZCBCST_DAY || 0);
          averages.ZCCCST_THIS += Number(row.ZCCCST_THIS || 0);
          averages.ZCDCST_TOT += Number(row.ZCDCST_TOT || 0);
        });

        // 평균값 계산
        Object.keys(averages).forEach((key) => {
          // '나이'와 '경력' 필드에 대해서만 평균을 계산합니다.
          if (key === "AGE" || key === "CAREER") {
            averages[key] = Math.round(averages[key] / len);
          } else if(key === "FILTER_RATIO" || key === "WIPER_RATIO" || key === "NEX_RATIO"){
            averages[key] = (averages[key] / len).toFixed(2);
          }
        });

        // 상단 고정행 데이터 업데이트
        this.storeCountPinnedTopRowData = [averages];
      },

      storeCountGridOptions: {
        headerHeight: 35,
        rowHeight: 22,
        quickFilterText: "",
        suppressHorizontalScroll: false,
        defaultColDef: {
          sortable: true,
          comparator: (valueA, valueB) => {
            const a = valueA == null || valueA === '' ? 0 : valueA;
            const b = valueB == null || valueB === '' ? 0 : valueB;

            const isANumber = !isNaN(parseFloat(a)) && isFinite(a);
            const isBNumber = !isNaN(parseFloat(b)) && isFinite(b);

            if (isANumber && isBNumber) {
              return a - b;
            }
            if (!isANumber && !isBNumber) {
              return String(a).localeCompare(String(b));
            }
            return isANumber ? -1 : 1;
          },
          resizable: false,
          headerStyle: {
            color: "black",
            textAlign: "center",
            backgroundColor: "#a0caf3",
            alignContent: "center",
          },
        },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
      },
    };
  },
  computed: {
    monthlyProjectedValue() {
      const currentMonth = new Date().getMonth() + 1; // 현재 월 (1-12)
      const projectedRow = this.totalMonthlyCountData[3]; // 4번째 행 (월예상)
      return projectedRow ? projectedRow[`M${currentMonth}`] : null;
    },

    // 현재 월인지 확인
    isCurrentMonth() {
      const now = new Date();
      return this.selectedMonth === now.getMonth() + 1;
    },

    dailySalesCountColumnDefs() {
      return [
        {
          headerName: `${this.selectedMonth}월`, // 동적
          headerStyle: {
            color: "black",
            backgroundColor: "#c0ffc0",
            textAlign: "center",
          },
          children: [
            {
              headerName: "",
              field: "week",
              flex: 0.8,
              cellStyle: {
                justifyContent: "center",
                backgroundColor: "#c0ffc0",
              },
            },
            {
              headerName: "일",
              field: "sun",
              flex: 1,
              valueFormatter: (params) => this.formatNumber(params.value),
              cellStyle: { justifyContent: "center" },
              cellClass: (params) => {
                if (this.isToday(params.data.dates?.sun)) {
                  return ["blinking-cell-yellow"];
                }
                return null;
              },
            },
            {
              headerName: "월",
              field: "mon",
              flex: 1,
              valueFormatter: (params) => this.formatNumber(params.value),
              cellStyle: { justifyContent: "center" },
              cellClass: (params) => {
                if (this.isToday(params.data.dates?.mon)) {
                  return ["blinking-cell-yellow"];
                }
                return null;
              },
            },
            {
              headerName: "화",
              field: "tue",
              flex: 1,
              valueFormatter: (params) => this.formatNumber(params.value),
              cellStyle: { justifyContent: "center" },
              cellClass: (params) => {
                if (this.isToday(params.data.dates?.tue)) {
                  return ["blinking-cell-yellow"];
                }
                return null;
              },
            },
            {
              headerName: "수",
              field: "wed",
              flex: 1,
              valueFormatter: (params) => this.formatNumber(params.value),
              cellStyle: { justifyContent: "center" },
              cellClass: (params) => {
                if (this.isToday(params.data.dates?.wed)) {
                  return ["blinking-cell-yellow"];
                }
                return null;
              },
            },
            {
              headerName: "목",
              field: "thu",
              flex: 1,
              valueFormatter: (params) => this.formatNumber(params.value),
              cellStyle: { justifyContent: "center" },
              cellClass: (params) => {
                if (this.isToday(params.data.dates?.thu)) {
                  return ["blinking-cell-yellow"];
                }
                return null;
              },
            },
            {
              headerName: "금",
              field: "fri",
              flex: 1,
              valueFormatter: (params) => this.formatNumber(params.value),
              cellStyle: { justifyContent: "center" },
              cellClass: (params) => {
                if (this.isToday(params.data.dates?.fri)) {
                  return ["blinking-cell-yellow"];
                }
                return null;
              },
            },
            {
              headerName: "토",
              field: "sat",
              flex: 1,
              valueFormatter: (params) => this.formatNumber(params.value),
              cellStyle: { justifyContent: "center" },
              cellClass: (params) => {
                if (this.isToday(params.data.dates?.sat)) {
                  return ["blinking-cell-yellow"];
                }
                return null;
              },
            },
          ],
        },
      ];
    },

    dailyLastSalesCountColumnDefs() {
      return [
        {
          headerName: `전년 ${this.selectedMonth}월`, // 동적
          headerStyle: {
            color: "black",
            backgroundColor: "#a0caf3",
          },
          children: [
            {
              headerName: "",
              field: "week",
              flex: 0.8,
              cellStyle: {
                justifyContent: "center",
                backgroundColor: "#a0caf3",
              },
            },

            {
              headerName: "일",
              field: "sun",
              flex: 1,
              valueFormatter: (params) => this.formatNumber(params.value),
              cellStyle: (params) => ({
                justifyContent: "center",
                backgroundColor: this.isToday(params.data.dates?.sun)
                  ? "#fff3e0"
                  : "white",
              }),
            },
            {
              headerName: "월",
              field: "mon",
              flex: 1,
              valueFormatter: (params) => this.formatNumber(params.value),
              cellStyle: (params) => ({
                justifyContent: "center",
                backgroundColor: this.isToday(params.data.dates?.mon)
                  ? "#fff3e0"
                  : "white",
              }),
            },
            {
              headerName: "화",
              field: "tue",
              flex: 1,
              valueFormatter: (params) => this.formatNumber(params.value),
              cellStyle: (params) => ({
                justifyContent: "center",
                backgroundColor: this.isToday(params.data.dates?.tue)
                  ? "#fff3e0"
                  : "white",
              }),
            },
            {
              headerName: "수",
              field: "wed",
              flex: 1,
              valueFormatter: (params) => this.formatNumber(params.value),
              cellStyle: (params) => ({
                justifyContent: "center",
                backgroundColor: this.isToday(params.data.dates?.wed)
                  ? "#fff3e0"
                  : "white",
              }),
            },
            {
              headerName: "목",
              field: "thu",
              flex: 1,
              valueFormatter: (params) => this.formatNumber(params.value),
              cellStyle: (params) => ({
                justifyContent: "center",
                backgroundColor: this.isToday(params.data.dates?.thu)
                  ? "#fff3e0"
                  : "white",
              }),
            },
            {
              headerName: "금",
              field: "fri",
              flex: 1,
              valueFormatter: (params) => this.formatNumber(params.value),
              cellStyle: (params) => ({
                justifyContent: "center",
                backgroundColor: this.isToday(params.data.dates?.fri)
                  ? "#fff3e0"
                  : "white",
              }),
            },
            {
              headerName: "토",
              field: "sat",
              flex: 1,
              valueFormatter: (params) => this.formatNumber(params.value),
              cellStyle: (params) => ({
                justifyContent: "center",
                backgroundColor: this.isToday(params.data.dates?.sat)
                  ? "#fff3e0"
                  : "white",
              }),
            },
          ],
        },
      ];
    },
  },
  methods: {
    refreshPage() {
      this.reloadData();
    },
    async reloadData() {
      this.isLoading = true;
      try {
        await this.fetchBranchList();
        if (this.userInfo.OGN_FG === "01") {
          await this.fetchStoreCount();
        } else {
          await Promise.all([
            this.fetchMonthlySalesCount(),
            this.fetchDailySalesCount(),
            this.fetchDailyLastSalesCount(),
            this.fetchTotalSale(),
            this.fetchAvgCount(),
            this.fetchStoreCount(),
          ]);
        }
      } catch (error) {
        console.error("데이터 새로고침 중 오류 발생:", error);
      } finally {
        this.isLoading = false;
      }
    },
    formatNumber(value) {
      // 값이 있을 경우에만 처리
      if (value) {
        // 소숫점이 있는 경우 반올림
        const roundedValue = Math.round(Number(value));
        // 천단위 구분자 추가
        return roundedValue.toLocaleString();
      }
      return "";
    },
    async fetchMonthlySalesCount() {
      try {
        const response = await axios.get(
          "/api/trListPage/fetchMonthlySalesCount"
        );
        // 필터 와이퍼 수량 추가 20260903
        const { salesData, contractRow, filterRow, wiperRow } = response.data;
        let data = salesData.filter(
          (row) =>
            row.TITLE !== "목표" &&
            row.TITLE !== "현금매출" &&
            row.TITLE !== "차이"
        );

        // M_ROW 값 순으로 정렬
        data.sort((a, b) => a.M_ROW - b.M_ROW);

        if (data.length > 3) {
          const maxValues = {};
          const dataBeforeRow3 = data.slice(0, 3);

          for (let i = 1; i <= 12; i++) {
            const monthField = `M${i}`;
            maxValues[monthField] = Math.max(
              ...dataBeforeRow3.map((row) => Number(row[monthField] || 0))
            );
          }

          // 각 행에 maxValues 추가 (cellStyle에서 접근하기 위함)
          data.forEach((row) => {
            row.maxValues = maxValues;
          });

          const row3 = data[3];
          const differenceRow = { TITLE: "차이", M_ROW: 4 };
          for (let i = 1; i <= 12; i++) {
            const monthField = `M${i}`;
            differenceRow[monthField] = row3[monthField]
              ? (row3[monthField] || 0) - (maxValues[monthField] || 0)
              : null;
          }
          data.splice(4, 0, differenceRow);
          // row5: 계약수량 (백엔드에서 내려준 contractRow)
          data.splice(5, 0, contractRow);

          // row6: 계약차이 (row3 - 계약수량)
          const row6 = { TITLE: "계약차이", M_ROW: 6, M_SUM: 0 };
          for (let i = 1; i <= 12; i++) {
            const monthField = `M${i}`;
            row6[monthField] = row3[monthField]
              ? (row3[monthField] || 0) - (contractRow[monthField] || 0)
              : null;
            row6.M_SUM += row6[monthField];
          }
          data.splice(6, 0, row6);
          // 필터 와이퍼 수량 추가 20260903
          data.splice(10, 0, filterRow);
          data.splice(11, 0, wiperRow);
        }

        this.totalMonthlyCountData = data;
      } catch (error) {
        console.error("fetchMonthlySalesCount 로딩 실패:", error);
      }
    },

    isToday(dateStr) {
      if (!dateStr) return false;
      const todayDate = new Date();
      const year = todayDate.getFullYear();
      const month = String(todayDate.getMonth() + 1).padStart(2, "0");
      const day = String(todayDate.getDate()).padStart(2, "0");
      const today = `${year}${month}${day}`;

      return dateStr === today;
    },

    processCalendarData(rawData) {
      const calendarData = [];
      const weeks = {};
      const weekDates = {};

      // 첫 날짜로부터 해당 월의 첫째 주 시작일 구하기
      const firstDate = new Date(
        rawData[0].YYYYMMDD.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3")
      );
      const startDate = new Date(
        firstDate.getFullYear(),
        firstDate.getMonth(),
        1
      );
      const firstWeekDay = startDate.getDay(); // 0: 일요일, 6: 토요일

      // 데이터를 주차별로 정리
      rawData.forEach((item) => {
        const date = new Date(
          item.YYYYMMDD.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3")
        );
        const weekNum = Math.ceil((date.getDate() + firstWeekDay) / 7);
        const weekKey = `${weekNum}주`;

        if (!weeks[weekKey]) {
          weeks[weekKey] = {};
          weekDates[weekKey] = {};
        }

        // YYYYMMDD의 일자와 요일 매핑
        const dayIndex = date.getDay(); // 0(일) ~ 6(토)
        const dayMap = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
        const dayKey = dayMap[dayIndex];

        weeks[weekKey][dayKey] = item.SALE_QTY;
        weekDates[weekKey][dayKey] = item.YYYYMMDD;
      });

      // 주차 순서대로 정렬하여 달력 데이터 생성
      Object.keys(weeks)
        .sort((a, b) => parseInt(a) - parseInt(b))
        .forEach((week) => {
          calendarData.push({
            week,
            sun: weeks[week].sun || "",
            mon: weeks[week].mon || "",
            tue: weeks[week].tue || "",
            wed: weeks[week].wed || "",
            thu: weeks[week].thu || "",
            fri: weeks[week].fri || "",
            sat: weeks[week].sat || "",
            dates: weekDates[week],
          });
        });

      return calendarData;
    },

    async fetchDailySalesCount() {
      try {
        const params = {};
        if (this.selectedBranch !== "00") {
          params.branchCd = this.selectedBranch;
        }
        if (this.selectedMonth) {
          params.selectedMonth = this.selectedMonth;
        }
        const response = await axios.get(
          "/api/trListPage/fetchDailySalesCount",
          { params }
        );
        this.dailySalesCountData = this.processCalendarData(response.data);
      } catch (error) {
        console.error("fetchDailySalesCount 로딩 실패:", error);
      }
    },

    async onBranchChange() {
      this.isLoading = true;
      // 본부 선택이 변경될 때
      await Promise.all([
        this.fetchDailyLastSalesCount(),
        this.fetchDailySalesCount(),
        this.fetchStoreCount(),
      ]);
      this.isLoading = false;
    },

    async fetchDailyLastSalesCount() {
      try {
        const params = {};
        if (this.selectedBranch !== "00") {
          params.branchCd = this.selectedBranch;
        }
        if (this.selectedMonth) {
          params.selectedMonth = this.selectedMonth;
        }
        const response = await axios.get(
          "/api/trListPage/fetchDailyLastSalesCount",
          { params }
        );
        this.dailyLastSalesCountData = this.processCalendarData(response.data);
      } catch (error) {
        console.error("fetchDailyLastSalesCount 로딩 실패:", error);
      }
    },

    async fetchTotalSale() {
      try {
        const response = await axios.get("/api/trListPage/fetchTotalSale");
        this.totalSaleData = response.data;
      } catch (error) {
        console.error("fetchTotalSale 로딩 실패:", error);
      }
    },

    async fetchAvgCount() {
      try {
        const response = await axios.get("/api/trListPage/fetchAvgCount");
        this.avgCountData = response.data;
        this.calculateAverages(); // 데이터 로드 후 평균 계산
      } catch (error) {
        console.error("fetchAvgCount 로딩 실패:", error);
      }
    },

    async fetchStoreCount() {
      try {
        const params = {};
        if (this.selectedBranch !== "00") {
          params.branchCd = this.selectedBranch;
        }
        if (this.selectedMonth) {
          params.selectedMonth = this.selectedMonth;
        }
        if (this.userInfo.OGN_FG == "01") {
          params.shopNm = this.userInfo.SHOP_NM;
        }

        const response = await axios.get("/api/trListPage/fetchStoreCount", {
          params,
        });
        this.storeCountData = response.data;
        this.calculateStoreCountAverages();
      } catch (error) {
        console.error("fetchAvgCount 로딩 실패:", error);
      }
    },

    async fetchBranchList() {
      try {
        const res = await axios.get("/api/trListPage/center");
        this.branchList = res.data;
        if (this.branchList && this.branchList.length > 0) {
          this.selectedBranch = this.branchList[0].BRANCH_CD; // 기본값으로 첫 번째 본부 선택
        }
      } catch (error) {
        console.error("본부 목록 로딩 실패:", error);
        alert("본부 목록을 불러오는 데 실패했습니다.");
      }
    },

    onGridReady(params) {
      this.gridApi = params.api;
    },

    storeCountCopy() {
      this.copyData(this.gridApi);
    },
    copyData(gridApi) {
      if (!gridApi) {
        alert("그리드 복사 기능을 사용할 수 없습니다. 데이터를 다시 불러온 후 다시 시도해주세요.");
        return;
      }
      const csvData = gridApi.getDataAsCsv({
        // 헤더 가공: \n 제거
        processHeaderCallback: (params) => {
          const def = params.column.getColDef();
          const header = def.headerName ?? def.field ?? "";
          return String(header).replace(/\r?\n/g, " "); // 줄바꿈 → 공백
        },
        // 셀 값 가공(필요하면): 셀 안의 줄바꿈도 제거
        processCellCallback: (params) => {
          const v = params.value;
          if (v == null) return "";
          return String(v).replace(/\r?\n/g, " ");
        },
        // 엑셀 친화 옵션
        columnSeparator: "\t", // 탭 구분 → 엑셀에 바로 셀 분리
        suppressQuotes: true, // 큰따옴표 억제(헤더에 따옴표 생기는 문제 방지)
      });

      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(csvData)
          .then(() => alert("복사되었습니다."))
          .catch((err) => console.error("Clipboard copy failed: ", err));
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = csvData;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        alert("복사되었습니다.");
      }
    },

    onQuickFilterChanged(event) {
      const filterValue = event.target.value; // 입력 필드 값 가져오기
      if (this.gridApi) {
        this.gridApi.setGridOption("quickFilterText", filterValue); // quickFilter 적용
      } else {
        console.error("Grid API is not initialized.");
      }
    },

    // 월 감소
    decreaseMonth() {
      if (this.selectedMonth === 1) {
        return;
      } else {
        this.selectedMonth--;
      }
      this.reloadMonthData();
    },

    // 월 증가
    increaseMonth() {
      if (!this.isCurrentMonth) {
        this.selectedMonth++;
        this.reloadMonthData();
      }
    },

    // 선택된 월의 데이터 리로드
    async reloadMonthData() {
      this.isLoading = true;
      try {
        // 달력 데이터 리로드
        await Promise.all([
          this.fetchDailySalesCount(),
          this.fetchDailyLastSalesCount(),
          this.fetchStoreCount(),
          this.calculateStoreCountAverages(),
        ]);
      } catch (error) {
        console.error("데이터 리로드 실패:", error);
      } finally {
        this.isLoading = false;
      }
    },

    avgCountCellStyle(params) {
      const style = { justifyContent: "center" };
      const field = params.colDef.field;

      // 상단 고정 행 스타일
      if (params.node.rowPinned === "top") {
        style.backgroundColor = "#fbaad0";
        if (field == "ZPOINT_BRANCH_NM") {
          style.justifyContent = "center";
        } else {
          style.justifyContent = "right";
        }
        return style;
      }

      // "NO" 컬럼 스타일
      if (field === undefined) {
        style.backgroundColor = "#dcb9ff";
        style.justifyContent = "center";
      } else if (field && field.endsWith("_BRANCH_NM")) {
        // "본부" 컬럼들
        style.backgroundColor = "#ffffbb";
      } else {
        style.justifyContent = "right";
      }

      if (params.rowIndex === 4) {
        // 5번째 행
        style.backgroundColor = "#00ff00";
      }

      return style;
    },

    avgCountcellClass(params) {
      if (params.rowIndex === 8) {
        return ["blinking-cell-yellow"];
      } else if (params.rowIndex === 9) {
        return ["blinking-cell-red"];
      }
    },

    storeCountCellStyle(params) {
      const style = {};
      const field = params.colDef.field;
      const centerAlignFields = [
        "VAN_BIZ_NO",
        "SHOP_NM",
        "SHOP_MASTER_NM",
        "ZK_SURETY_ED",
        "TRBIZ_TYPE",
        "OPEN_HR",
        "CLOSE_HR",
      ];

      // 상단 고정 행 스타일
      if (params.node.rowPinned === "top") {
        style.backgroundColor = "#dedfde";
        style.borderColor = "#FF0000";
      }

      if (centerAlignFields.includes(field)) {
        style.justifyContent = "center";
      } else {
        style.justifyContent = "right";
      }

      return style;
    },
    onStoreCountDoubleClicked(params) {
      if (params.colDef.field === "SHOP_NM") {
        if (params.node.rowPinned) return;
        this.popupShopCd = params.data.SHOP_CD;
        this.popupShopNm = params.data.SHOP_NM;
        this.showPopup = true;
      }
    },
    closePopup() {
      this.showPopup = false;
    },

    async onStoreCountCellValueChanged(params) {
      
      const { colDef, data, newValue, oldValue } = params;

      if (newValue === oldValue) {
        return;
      }

      // SHOP_CD가 데이터에 없으면 업데이트 불가.
      if (!data.SHOP_CD) {
        console.error("SHOP_CD가 없어 업데이트할 수 없습니다.");
        alert("업데이트에 필요한 정보(SHOP_CD)가 없습니다.");
        data[colDef.field] = oldValue; // 데이터만 복구
        params.api.refreshCells({ rowNodes: [params.node] });
        return;
      }

      if (colDef.field === "LASTPROFIT") {
        try {
          await axios.post("/api/trListPage/saveLastProfit", {
            shopCd: data.SHOP_CD,
            newValue: newValue ?? 0,
            index: 0
          });
          this.calculateStoreCountAverages();
          alert("저장되었습니다.");
        } catch (error) {
          console.error("데이터 저장 실패:", error);
          alert("데이터 저장 중 오류가 발생했습니다.");
          data[colDef.field] = oldValue; // 데이터만 복구
          params.api.refreshCells({ rowNodes: [params.node] });
        }
        return;
      }

      if (colDef.field === "PROFIT") {
        try {
          await axios.post("/api/trListPage/saveLastProfit", {
            shopCd: data.SHOP_CD,
            newValue: newValue ?? 0,
            index: 1
          });
          this.calculateStoreCountAverages();
          alert("저장되었습니다.");
        } catch (error) {
          console.error("데이터 저장 실패:", error);
          alert("데이터 저장 중 오류가 발생했습니다.");
          data[colDef.field] = oldValue; // 데이터만 복구
          params.api.refreshCells({ rowNodes: [params.node] });
        }
        return;
      }

      if (colDef.field === "STAFF_CNT") {
        try {
          await axios.post("/api/trListPage/saveStaffCnt", {
            shopCd: data.SHOP_CD,
            userId: this.userInfo.userId,
            toCnt: data.TO_CNT || 0,
            workerCnt: data.STAFF_CNT || 0,
          });
          this.calculateStoreCountAverages();
          alert("저장되었습니다.");
        } catch (error) {
          console.error("데이터 저장 실패:", error);
          alert("데이터 저장 중 오류가 발생했습니다.");
          data[colDef.field] = oldValue; // 데이터만 복구
          params.api.refreshCells({ rowNodes: [params.node] });
        }
        return;
      }

      if (["SHOP_MASTER_NM", "AGE", "CAREER"].includes(colDef.field)) {
        try {
          await axios.post("/api/trListPage/saveMasterInfo", {
            shopCd: data.SHOP_CD,
            shopMasterNm: data.SHOP_MASTER_NM, 
            age: data.AGE,
            career: data.CAREER,
          });
          this.calculateStoreCountAverages(); // 나이/경력 평균 재계산
          alert("저장되었습니다.");
        } catch (error) {
          console.error("데이터 저장 실패:", error);
          alert("데이터 저장 중 오류가 발생했습니다.");
          data[colDef.field] = oldValue; // 데이터만 복구
          params.api.refreshCells({ rowNodes: [params.node] });
        }
        return;
      }
    },

    onSortChanged(params) {
      // 정렬 후 실행할 로직
      let i = 1;
      params.api.forEachNode((node) => {
        if (!node.rowPinned) {
          node.data.No = i++;
        }
      });
      // No 컬럼 갱신
      params.api.refreshCells({ columns: ['no'] });
    }
  },
  watch: {},
  mounted() {
    const userInfoString = localStorage.getItem("userInfo");
    if (userInfoString) {
      this.userInfo = JSON.parse(userInfoString);
    }

    const topTranData = {
      shopName: this.userInfo?.SHOP_NM || "본사로그인",
      telNo: this.userInfo?.TEL_NO,
    };

    this.$emit("top-info-change", topTranData);

    this.reloadData();
  },
};
</script>

<style scoped>
.tr-list-page {
  padding: 2px;
  height: 99%;
  display: flex;
  flex-direction: column;
  /* gap: 8px; */
}

.main-grid-layout {
  display: grid;
  grid-template-columns: 1.2fr 1.2fr 0.5fr 1fr; /* 4개의 동일한 너비의 컬럼 */
  grid-template-rows: 1.25fr 0.9fr 0.1fr 1.45fr;
  grid-template-areas:
    "sales-area sales-area sales-area monthly-stats-area"
    "middle-area middle-area middle-area monthly-stats-area"
    "search-area search-area search-area search-area"
    "bottom-area bottom-area bottom-area bottom-area";
  height: 100%;
}

.sales-grid {
  grid-area: sales-area;
}
.monthly-stats-grid {
  grid-area: monthly-stats-area;
}
.middle-container {
  grid-area: middle-area;
}
.search-section {
  grid-area: search-area;
}
.bottom-grid {
  grid-area: bottom-area;
}

.middle-container {
  display: grid;
  grid-template-columns: 1fr 1fr 0.4fr;
  /* align-items: stretch; 내부 아이템들이 높이를 채우도록 함 */
}

.stats-table table {
  font-size: 0.75rem;
  border: 1px solid black;
  border-collapse: collapse;
  width: 100%;
  height: 100%;
}

.stats-table th {
  border: 1px solid black;
  text-align: center;
  padding: 4px;
  background-color: #f0f0f0;
  font-weight: normal;
}

.stats-table td {
  border: 1px solid black;
  text-align: right;
  padding: 4px;
  background-color: #ffacd6;
}

.search-section {
  border: 1px solid #ccc;
  display: flex;
  align-items: center; /* 세로 중앙 정렬 */
}

.search-section .info-label {
  padding: 6px 12px;
  border: 1px solid #ccc;
  font-size: 1rem;
  background-color: #ffc080;
  white-space: nowrap; /* 줄바꿈 방지 */
}

.search-section .branch-select {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-right: 10px;
}

.search-section .search-input {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-right: 10px;
}

.month-control {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #f0f0f0;
  padding: 5px 10px;
  border-radius: 4px;
}

.month-btn {
  padding: 4px 8px;
  border: 1px solid #ccc;
  background-color: white;
  cursor: pointer;
  border-radius: 4px;
}

.month-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.month-display {
  font-size: 1rem;
  font-weight: bold;
  min-width: 120px;
  text-align: center;
}

.refresh-btn {
  margin-left: auto;
  padding: 8px 12px;
  border: 1px solid #ccc;
  background-color: #e0e0e0;
  cursor: pointer;
  border-radius: 4px;
  font-size: 0.9rem;
}

.refresh-btn:hover {
  background-color: #d0d0d0;
}

:deep(.ag-tr-balham) {
  font-family: "맑은 고딕", Malgun Gothic, sans-serif; /* VB 설정과 동일 */
  --ag-cell-horizontal-padding: 1.5px; /* 셀 내부 좌우 패딩 */
  --ag-cell-vertical-padding: 1px; /* 셀 내부 상하 패딩 */
}

:deep(.ag-tr-balham .ag-header-cell-comp-wrapper) {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* grid 헤더 텍스트 정렬 */
:deep(.ag-tr-balham .ag-header-cell-label) {
  justify-content: center !important;
  white-space: pre-line;
  align-items: center !important;
  font-weight: normal;
  font-size: 0.7rem;
}

:deep(.ag-tr-balham .ag-cell) {
  font-size: 0.7rem;
  display: flex;
  align-items: center; /* 수직 중앙 정렬 textAlign 안먹고 justifyContent 적용 가운데로 잘 안와서*/
}

:deep(.middle-grid .ag-cell) {
  font-size: 0.75rem;
  display: flex;
  align-items: center; /* 수직 중앙 정렬 */
}

/* 각 그리드 컨테이너 공통 스타일 */
.sales-grid,
.group-grid,
.right-stats-grid,
.monthly-stats-grid,
.bottom-grid {
  border: 1px solid #ccc;
  background: white;
}

:deep(.blinking-cell-red) {
  animation: blink-effect-red 1s step-end infinite;
  animation-delay: 0s;
}

@keyframes blink-effect-red {
  0%,
  100% {
    background-color: #ff0000; /* 빨간색 */
  }
  50% {
    background-color: #ffffff; /* 하얀색 */
  }
}

:deep(.blinking-cell-yellow) {
  animation: blink-effect-yellow 1s step-end infinite;
  animation-delay: 0s;
}

@keyframes blink-effect-yellow {
  0%,
  100% {
    background-color: #fff000; /* 빨간색 */
  }
  50% {
    background-color: #ffffff; /* 하얀색 */
  }
}

/* 1024px 초과일 때 폰트/행 높이 증가 */
@media (min-width: 1025px) {
  .stats-table table {
    font-size: 1rem;
  }

  :deep(.ag-tr-balham .ag-cell) {
    font-size: 0.85rem;
  }
  :deep(.middle-grid .ag-cell) {
    font-size: 1rem;
  }
  :deep(.top-grid .ag-cell) {
    font-size: 1rem;
  }

  :deep(.ag-tr-balham .ag-header-cell-text) {
    font-size: 0.8rem;
  }
  :deep(.middle-grid .ag-header-cell-text, .top-grid .ag-header-cell-text) {
    font-size: 0.9rem;
  }
}
</style>
